import { PHONEMES } from "../content/phonemes";
import type { Profile } from "../state/profile";
import { weakestPhonemes } from "./soundmap";

/** One specific line for the Session Card — grounded in this profile's real
    data (the actual weakest sound), not a generic "great job!". */
export function coachingNote(profile: Profile, sessionClarity: number): string {
  const weakestId = weakestPhonemes(profile, 1)[0];
  const phoneme = weakestId ? PHONEMES.find((p) => p.id === weakestId) : undefined;
  if (phoneme) {
    return `Your ${phoneme.label} is the weakest sound on your map — tomorrow's session will lean on it.`;
  }
  return `${sessionClarity} Clarity banked. Show up again tomorrow and keep the ring closing.`;
}
